import { useQuery } from '@tanstack/react-query';

import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';
import { getSharedSprintsQueryKey } from 'api/utils';

import { mapSprints } from 'features/sprint/utils';

export const useSharedSprintsQuery = (email, options = {}) => {
  const { request } = useQueryHTTPRequest();

  return useQuery(
    getSharedSprintsQueryKey(email),
    async ({ signal }) =>
      await request({ url: `/api/sprintmates/${email}/sprints`, signal }),
    {
      select: (data) =>
        mapSprints({
          sprints: Array.isArray(data?.items) ? data.items : [],
        }),
      ...options,
    }
  );
};
